import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClock,
  faDollarSign,
  faHorseHead
} from '@fortawesome/free-solid-svg-icons';
import { INikkeTierNode } from '../../../common/model/graphql-types';

interface IProps {
  character: INikkeTierNode;
}

export const NikkeCharacterVariables: React.FC<IProps> = ({ character }) => {
  return (
    <>
      {character && (
        <>
          {character.New === 'Yes' ? (
            <>
              <span className="tag new">New</span>
              <div className="tag-container with-new">
                {character.Investment === 'Yes' && (
                  <span className="new-tag invest">
                    <FontAwesomeIcon icon={faDollarSign} width="18" />
                  </span>
                )}
                {character.Limited === 'Yes' && (
                  <span className="new-tag limited">
                    <FontAwesomeIcon icon={faClock} width="18" />
                  </span>
                )}
                {character.Treasure === 'Yes' && (
                  <span className="new-tag treasure">
                    <FontAwesomeIcon icon={faHorseHead} width="18" />
                  </span>
                )}
              </div>
            </>
          ) : (
            <div className="tag-container">
              {character.Investment === 'Yes' && (
                <span className="new-tag invest">
                  <FontAwesomeIcon icon={faDollarSign} width="18" />
                </span>
              )}
              {character.Limited === 'Yes' && (
                <span className="new-tag limited">
                  <FontAwesomeIcon icon={faClock} width="18" />
                </span>
              )}
              {character.Treasure === 'Yes' && (
                <span className="new-tag treasure">
                  <FontAwesomeIcon icon={faHorseHead} width="18" />
                </span>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};
